import { Link } from 'react-router';
import { UserRound } from 'lucide-react';
import { useAuth } from '@/auth/store';
import { Avatar } from '@/components/Avatar';
import { useTeam } from '@/team/store';
import { ROLE_LABEL } from '@/team/roles';

/** Top-right: photo or initials and the name when signed in; a person icon and "Sign in" when not. */
export function AccountPill() {
  const { status, user } = useAuth();
  const role = useTeam((s) => s.membership?.role);
  const signedIn = status === 'signedIn' && !!user;
  const to = signedIn ? '/settings/account' : '/auth';
  const text = signedIn ? (user.name ?? user.email) : status === 'loading' ? 'Checking…' : 'Sign in';

  return (
    <Link to={to} aria-label={signedIn ? 'Account' : 'Sign in'}
      className="flex items-center gap-2 h-[34px] pl-1 pr-[10px] rounded-[17px] border border-border bg-card text-[12.5px] font-bold no-underline text-ink hover:bg-inset">
      {signedIn
        ? <Avatar user={user} />
        : <span aria-hidden="true" className="w-[26px] h-[26px] rounded-full bg-inset text-ink-2 grid place-items-center"><UserRound size={14} strokeWidth={2.2} /></span>}
      <span className={`hidden sm:inline ${signedIn ? 'text-ink font-bold max-w-[140px] truncate' : 'text-ink-2'}`}>{text}</span>
      {role && role !== 'member' && <span className="hidden sm:inline text-[10.5px] font-extrabold uppercase text-ink-2 bg-inset rounded-[4px] px-[6px] py-[2px]">{ROLE_LABEL[role]}</span>}
    </Link>
  );
}
